import { lazyWithPreload } from '../../navigation';

export const AgentScreen = lazyWithPreload(() => import('./AgentScreen.lazy'));
